module.exports = __webpack_public_path__ + "static/media/IconMenuE.4e2f13b6.svg";